<template>
  <div class="pos-task-info">
    <div class="table-no">
      {{ $t('kdu.table') }}
      <b>{{ table.table_no }}</b>
    </div>
    <div class="order-no">{{ $t('kdu.orderNo') }}: # {{ table.order_no }}</div>
    <!-- <div class="order-type">
      <span class="label label-success">Dine-in</span>
    </div>
    <div class="time-pass" data-start-time="3">07:13 time</div> -->
  </div>
</template>

<script>
export default {
  props: ['table']
}
</script>